"use client";

import { memo } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { selectFilterOptions } from "@/feature/flight/search/state/selectors";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  setFilters,
} from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import AccordionSection from "./accordion-section";

const LayoverCity = memo(() => {
  const dispatch = useAppDispatch();
  const { selectOption, defaultOption } = useAppSelector(
    selectFilterOptions,
  );
  const isResponseEnd = useAppSelector((state) => state.flightSearchStatus.isResponseEnd);

  const selected = selectOption?.layover_city ?? [];
  const layover_city = defaultOption?.layover_city ?? [];

  const handleChange = (value?: string) => {
    if (!value) return;

    const isSelected = selected.includes(value);

    const updatedValue = isSelected
      ? selected.filter((item) => item !== value)
      : [...selected, value];

    dispatch(setFilters({ layover_city: updatedValue }));
  };

  if (!layover_city.length) return null;

  return (
    <AccordionSection value="layover_city" label="Layover City">
      {layover_city.map((item) => (
        <div key={item.code} className="flex items-center space-x-2">
          <Checkbox
            disabled={!isResponseEnd}
            id={item.code}
            checked={selected.includes(item.code!)}
            onCheckedChange={() => handleChange(item.code)}
          />
          <Label
            htmlFor={item.code}
            className="font-normal cursor-pointer w-full"
          >
            <div className="flex flex-col truncate">
              <span>{item.code}</span>
              <span className="truncate max-w-60 font-light text-xs">
                {item.airport}
              </span>
            </div>
          </Label>
        </div>
      ))}
    </AccordionSection>
  );
});

LayoverCity.displayName = "LayoverCity";

export default LayoverCity;


